var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrackField(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_13270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2134 8.26235C22.7991 7.51643 21.8584 7.24765 21.1125 7.66207L18.6612 9.02393L17.0453 6.55268C16.9975 6.55437 16.9498 6.55634 16.9016 6.55634C15.2741 6.55634 13.8723 5.57421 13.2557 4.1719C11.361 4.17176 8.16351 4.17157 8.16351 4.17157C7.60035 4.17157 7.08182 4.47799 6.81013 4.97126L4.8531 8.52485C4.44149 9.27232 4.7137 10.2119 5.46112 10.6235C5.69746 10.7537 5.95302 10.8155 6.20507 10.8155C6.74999 10.8155 7.27837 10.5266 7.5598 10.0155L9.07645 7.26162H11.9944L7.53932 15.0383H2.13782C1.28455 15.0383 0.592773 15.7301 0.592773 16.5834C0.592773 17.4366 1.28451 18.1284 2.13782 18.1284H8.42099C8.96741 18.1284 9.4732 17.8399 9.75116 17.3694L10.861 15.4912L13.663 17.6988L11.9831 21.8783C11.6648 22.67 12.0486 23.5698 12.8404 23.888C13.0293 23.964 13.2243 23.9999 13.4161 23.9999C14.0284 23.9999 14.6079 23.6336 14.8502 23.0307L16.9617 17.7776C17.2176 17.1411 17.0232 16.4122 16.4844 15.9877L13.3776 13.5399L15.5256 9.87494L16.8616 11.9182C17.1566 12.3694 17.65 12.6179 18.1559 12.6179C18.4103 12.6179 18.6681 12.555 18.9051 12.4233L22.6132 10.3632C23.3591 9.94891 23.6279 9.00827 23.2134 8.26235Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9012 5.15016C18.3234 5.15016 19.4763 3.99725 19.4763 2.57508C19.4763 1.1529 18.3234 0 16.9012 0C15.4791 0 14.3262 1.1529 14.3262 2.57508C14.3262 3.99725 15.4791 5.15016 16.9012 5.15016Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_13270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackField);
export default __webpack_public_path__ + "static/media/track___field.034b93bd0c14e6ee36236b78970fe92e.svg";
export { ForwardRef as ReactComponent };